<template>
  <v-btn
    class="text-none"
    :icon="icon"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>
      <v-icon
        v-if="iconProps.icon"
        :class="iconProps.class"
        :size="iconProps.size"
        :color="iconProps.color"
        :large="iconProps.large"
        :small="iconProps.small"
        :left="!icon"
      >
        {{ iconProps.icon }}
      </v-icon>
    </slot>
    <span>{{ label }}</span>
  </v-btn>
</template>

<script>
  export default {
    name: 'CBtn',
    props: {
      label: {
        type: String,
        default: ''
      },
      iconProps: {
        type: Object,
        default: () => ({})
      },
      icon: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
